module.exports = __webpack_public_path__ + "img/pic_location_ChanghuaCity.c2aa1556.png";